import { styled } from '@mui/material/styles';
import {
  AppBar,
  Container,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Box,
  Typography
} from '@mui/material';

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: 'transparent',
  boxShadow: 'none',
  color: '#333',
  width: '100%',
  paddingTop: '10px',
  paddingBottom: '10px',
  paddingRight: 0,     // ✅ remove
  overflowX: 'clip',   // ✅ stops tiny 1-2px overflow if any
}));

export const StyledContainer = styled(Container)(() => ({
  paddingLeft:0,
  paddingRight:0
}));

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  paddingLeft: 0,
  paddingRight: 0,

  // [theme.breakpoints.up('md')]: {
  //   paddingLeft: 32,
  //   paddingRight: 32,
  // },
}));


export const StyledIconButton = styled(IconButton)(() => ({}));

export const StyledMenu = styled(Menu)(() => ({}));

export const StyledMenuItem = styled(MenuItem)(() => ({
  color: '#333',
  textAlign: 'center',
}));

export const StyledButton = styled(Button)(({ theme }) => ({
    color: '#333',
    // background:'#f7f7f7',
    textTransform: 'none',
    marginLeft: '25px',
    marginRight:'25px',
    // Use h6's font sizing & weight
    fontSize: '1.05rem',
    fontWeight: '500',
}));

export const StyledBox = styled(Box)(() => ({}));

export const Logo = styled(Typography)(() => ({
  fontFamily: 'monospace',
  fontWeight: 700,
  letterSpacing: '.2rem',
  textDecoration: 'none',
  color: '#333',
  marginLeft:'16px',
}));
